<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="-"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <a href="javascript:void(0)"  @click="urlTo('policyServiceIndex')">政策知识库</a> / <span>{{name}}详情</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div v-for="(item,index) in listData" class="details">
            <h2 class="details_tit1" style="    border-bottom: 1px solid #dcdcdc;">{{item.title}}
              <a @click="open(detail.title)" style="color: #2b60e2;font-size: 12px" href="javascript:void(0)"><u>纠错</u></a>
            </h2>
           <!-- <p class="details_time" style="display: none">
              <span> 发布日期：{{detail.policy_date}}</span>
            </p>-->
            <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab">
              <tr>
                <td width="8%" class="grey">发布单位</td>
                <td width="40%">{{item.unit}}</td>
                <td width="8%" class="grey">发布时间</td>
                <td width="40%">{{item.date}}</td>
              </tr>
              <tr>

                <td class="grey">附件下载</td>
                <td colspan="3"><a  v-for="item in attachList" :href="getFileUrl(item.attach_id)" target="_blank" style="margin-right: 10px;display: block" >【{{item.title}}】</a></td>
              </tr>
            </table>
            <div class="details_con">
              <div class="details_con_left" style="width: 97%;margin: 0 auto;border-bottom: 1px solid #dcdcdc;padding-bottom: 30px">
                <dl>
                  <dd v-html="item.content"></dd>
                </dl>
                <!--                <p v-if="!this.$util.isEmpty(detail.attachIdList)">附件：<a href="javascript:void(0)" @click="downloadAttach">{{detail.title}}</a></p>-->
              </div>
            </div>
            <div style="margin-top: 20px;padding-left: 50px">
            <b v-if="refData.length>0">相关政策</b>
            </div>
            <div style="padding-left: 50px;padding-top: 20px" v-for="(item,index) in refData">
              <a style="color: #2b60e2" href="javascript:void(0)" @click="urlTo('policyServiceIndex',{id:item.id})">【{{item.title}}】</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <el-dialog :title="title" :visible.sync="showFloat">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item  label="反馈标题" :label-width="formLabelWidth" prop='errorCorrectionName'>
          <el-input maxlength="50" v-model="ruleForm.errorCorrectionName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="反馈内容"  :label-width="formLabelWidth2" prop='errorCorrectionContent'>
          <el-input type="textarea" maxlength="249"  v-model="ruleForm.errorCorrectionContent" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div  slot="footer" class="dialog-footer">
        <el-button @click="showFloat = false">取 消</el-button>
        <el-button type="primary" :disabled="isDisabled" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <footers></footers>
  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";

  export default {
    name: "PolicyDetail",
    components: {
      headers, fixedDiv, footers
    },
    data() {
      return {
        ruleForm: {
          errorCorrectionName:'',
          errorCorrectionContent:'',
        },
        rules: {
          errorCorrectionName: [
            {required: true, message: '请输入', trigger: 'blur'},
          ],
          errorCorrectionContent: [
            {required: true, message: '请输入纠正内容', trigger: 'blur'},
          ],
        },
        formLabelWidth: '80px',
        formLabelWidth2: '80px',
        showFloat:false,
        isDisabled:false,
        detail: {},
        detail_id: '',
        name: '',
        title: '',
        listData: [],
        refData: [],
        attachList: [],
      }
    },
    mounted() {
      var t=this;
      this.$https.post("api/pu/peopleUserInfo.do",{},response=>{
        if (response.status === 200 && response.data.code===200) {
          if(response.data.data.isCertification=='1'){
            t.people_name=response.data.data.userName;
            t.people_id=response.data.data.userId;
            t.people_idcard=response.data.data.userIdcard;
            t.people_tel=response.data.data.userTel;
          }
        }
      })
    },
    created() {
      this.detail_id = this.$route.query.detail_id;
      this.saveType = this.$route.query.type;
      this.name = this.$route.query.name;
      this.getDetail();
    },
    methods: {
      getFileUrl(a){
        return this.$util.getAttach(a)
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isDisabled=true;
            var t=this;
            const options={
              peopleName:t.people_name,
              peopleId:t.people_id,
              knowId:t.detail_id,
              peopleIdcard:t.people_idcard,
              peopleTel:t.people_tel,
              errorCorrectionName:t.ruleForm.errorCorrectionName,
              errorCorrectionContent:t.ruleForm.errorCorrectionContent,
              feedbackType:t.saveType,
            }
            this.$https.post("/api/policy/saveError.do",options,response=>{
              if (response.status === 200 && response.data.code===200) {
                t.showFloat=false;
                this.$alert('提交成功，我们会尽快处理！', '', {
                  confirmButtonText: '确定',
                  callback: action => {

                  }
                });
              }else {
                this.$message.error('提交失败！请稍后重试');
                t.isDisabled=false;
              }
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //获取政策文件详细
      getDetail() {
        this.$https.post("/api/policy/getKnowledgeDeta.do", {id: this.detail_id}, response => {
          if (response.status === 200 && response.data.code === 200) {
            this.listData = response.data.data.listData;
            this.refData = response.data.data.refData;
            this.attachList = response.data.data.attachList;
            this.title=this.listData[0].title;
           /* $('#content').html(this.listData[0].content)*/
            // $('#policy_abstract').html(this.detail.policy_abstract)
          }
        });
      },
      open() {
        this.showFloat=true;
      },
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      },
      //下载附件
      // downloadAttach() {
      //   this.$https.downloadFile("/attach/download.do", {attachId: this.detail.attachIdList[0],}, response => {
      //   });
      // }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/detail/KnowDetail.vue